import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { SuretyOutreachCard } from "@/components/SuretyOutreachCard";

const FIELDS = [["first_name", "First name"], ["last_name", "Last name"], ["npn", "NPN"], ["carrier", "Appointed by (surety carrier)"],
  ["agency_name", "Agency name (optional)"], ["phone", "Phone"], ["street", "Mailing street"], ["city", "City"], ["state", "State"], ["zip_code", "ZIP"]];

export default function SuretyProfile() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/surety/profile").then((r) => setP(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!p) return null;
  const save = async () => {
    try { const { data } = await api.put("/surety/profile", p); setP(data); toast.success("Profile saved"); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div data-testid="surety-profile-page">
      <PageHeader title="My Agent Profile" subtitle="These details appear on every email and postcard you send." />
      <Card className="max-w-3xl p-6">
        <div className="grid gap-4 sm:grid-cols-2">
          {FIELDS.map(([k, l]) => (
            <div key={k}><Label className="text-xs">{l}</Label>
              <Input value={p[k] || ""} onChange={(e) => setP({ ...p, [k]: e.target.value })} data-testid={`surety-profile-${k}`} /></div>
          ))}
        </div>
        <p className="mt-4 text-xs text-slate-500">Emails are sent from Elite Leads with replies going to {p.email}. The mailing address is used as the postcard return address and in the email footer.</p>
        <Button className="mt-4" onClick={save} data-testid="surety-profile-save">Save profile</Button>
      </Card>
      <SuretyOutreachCard />
    </div>
  );
}
